import { useEffect } from 'react';
import { useLocalSearchParams, useRouter } from 'expo-router';
import { View, ActivityIndicator } from 'react-native';

export default function CustomPuzzleRoute() {
  const { id } = useLocalSearchParams();
  const router = useRouter();

  useEffect(() => {
    if (id) {
      // Bounce the user back to the main game screen, passing the puzzle ID 
      // as a query parameter so the bootstrapper can catch it.
      router.replace(`/?custom_puzzle=${id}`);
    }
  }, [id]);


  // Show a simple loading screen for the split second it takes to redirect
  return (
    <View style={{ flex: 1, backgroundColor: '#000', justifyContent: 'center', alignItems: 'center' }}>
      <ActivityIndicator color="#ba4b21" size="large" />
    </View>
  );
}